import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';

export const useSetFundraising = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.setFundraising(payload);
      const { status, data } = response;

      if (status === 200) {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status] }),
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status_by_id] }),
        ]);
        Notify.success({ text: t('fundraising:shared.fundraising_goal_successfully_set') });
        return data;
      }

      if (status === 400) {
        Notify.error({ text: data.message });
      }

      return null;
    },
  });
};
